import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import SettingsIcon from "@mui/icons-material/Settings";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import TagIcon from "@mui/icons-material/Tag";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

import { useSelector } from "react-redux";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { IconButton, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import FilterIcon from "@mui/icons-material/Filter";
import EventIcon from "@mui/icons-material/Event";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import CameraIcon from "@mui/icons-material/Camera";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  backgroundColor: "white",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": { ...openedMixin(theme), backgroundColor: "white" },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": { ...closedMixin(theme), backgroundColor: "white" },
  }),
}));

const menuItemsMagasin = {
  gerant: [
    { text: "Home", icon: <HomeIcon />, path: "/admin" },
    { text: "Commande", icon: <PermMediaIcon />, path: "/admin/command" },
    { text: "Dimension", icon: <AspectRatioIcon />, path: "/admin/Dimension" },
    { text: "Imprimante", icon: <PrintIcon />, path: "/admin/imprimant" },
    {
      text: "Camera",
      icon: <CameraAltIcon />,
      path: "/admin/CameraBox",
    },
    { text: "Search", icon: <SearchIcon />, path: "/admin/searchCommand" },
    { text: "Hashtags", icon: <TagIcon />, path: "/admin/hashtags" },
    { text: "Parametre", icon: <SettingsIcon />, path: "/admin/Parametre" },
  ],
  user: [
    { text: "Commande", icon: <PermMediaIcon />, path: "/admin/command" },
    { text: "Search", icon: <SearchIcon />, path: "/admin/searchCommand" },
  ],
};

const menuItemsEvent = {
  gerant: [
    /*  { text: "Home", icon: <HomeIcon />, path: "/admin" },*/
    { text: "Commande", icon: <PermMediaIcon />, path: "/admin/event" },
    { text: "Dimension", icon: <AspectRatioIcon />, path: "/admin/Dimension" },
    { text: "Imprimante", icon: <PrintIcon />, path: "/admin/imprimant" },
    {
      text: "Camera",
      icon: <CameraAltIcon />,
      path: "/admin/CameraBox",
    },
    { text: "Images", icon: <CameraIcon />, path: "/admin/takeImage" },
    {
      text: "Images Event",
      icon: <FilterIcon />,
      path: "/admin/imagesEvent",
    },
    { text: "Search", icon: <SearchIcon />, path: "/admin/searchCommand" },

    {
      text: "category hashtags",
      icon: <TagIcon />,
      path: "/admin/categoryHashtag",
    },
    { text: "Hashtags", icon: <TagIcon />, path: "/admin/hashtags" },

    /*  { text: "Search", icon: <SearchIcon />, path: "/admin/searchCommand" },
    { text: "Hashtags", icon: <TagIcon />, path: "/admin/hashtags" },
    { text: "Parametre", icon: <SettingsIcon />, path: "/admin/Parametre" },*/
  ],
  user: [
    { text: "Commande", icon: <PermMediaIcon />, path: "/admin/event" },
    { text: "Search", icon: <SearchIcon />, path: "/admin/searchCommand" },
  ],
};
const menuItemsAdmin = [
  /*  { text: "Home", icon: <HomeIcon />, path: "/admin" },*/
  { text: "Events", icon: <EventIcon />, path: "/admin/events" },
  { text: "Users", icon: <GroupIcon />, path: "/admin/users" },
  { text: "Produits", icon: <CategoryIcon />, path: "/admin/produits" },
];

export default function MenuDashboard() {
  const { user } = useSelector((state) => state.Auth);
  const role = user.Role;
  // حدد نوع المستخدم
  const menuItems =
    role === "admin"
      ? menuItemsAdmin
      : user?.idMagasin
      ? menuItemsMagasin[role] || []
      : menuItemsEvent[role] || [];

  const isMobile = useMediaQuery("(max-width: 768px)");
  const [open, setOpen] = useState(!isMobile); // مفتوح على desktop، مغلق على mobile

  const location = useLocation();

  // إغلاق drawer تلقائيًا عند تغيير الصفحة في الهاتف
  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <Box>
      {/* زر فتح/إغلاق فقط في الهاتف */}
      {isMobile && (
        <IconButton
          onClick={() => setOpen((prev) => !prev)}
          sx={{ position: "fixed", top: 16, left: 16, zIndex: 1300 }}
        >
          {open ? <ChevronLeft /> : <ChevronRight />}
        </IconButton>
      )}

      <Drawer
        variant="permanent"
        open={!isMobile}
        onClose={() => setOpen(false)} // مهم للهاتف فقط
        ModalProps={{
          keepMounted: true, // تحسين الأداء في الهاتف
        }}
      >
        <Box sx={{ marginTop: "80px", width: 250 }}>
          <ListDashboard open={open} role={role} menuItems={menuItems} />
        </Box>
      </Drawer>
    </Box>
  );
}

const ListDashboard = ({ open, menuItems, role }) => {
  /*  const handleDeconnection = () => {
    Cookies.remove("token");
    window.location.reload();
  };*/

  return (
    <List>
      {menuItems?.map((item, index) => (
        <Link
          key={index}
          to={item.path}
          style={{ textDecoration: "none", color: "black" }}
        >
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        </Link>
      ))}
    </List>
  );
};
